import React from 'react';
import { compose } from 'redux';
import CloakLoading from '../../../../components/CloakLoading';
import Translations from '../../../../containers/Translations';
import { codes } from '../../../../data/translations';
import { actionTypeEnum } from '../../consts';
import AuthenticationContextConnect from '../../decorators/authenticationContextConnect';
import AuthenticationDescription from '../AuthenticationDescription';
import AuthenticationTitle from '../AuthenticationTitle';
import { AuthenticationNewPasswordForm } from './AuthenticationNewPasswordForm';
import AuthenticationFetchNewPassword from './decorators/authenticationFetchNewPassword';
import classes from './styles/index.module.scss';
import { UserPasswordRequirements } from '../../../user/components/UserPasswordRequirements';

const AuthenticationNewPasswordComponent = ({
	passwordRules,
	actionType,
	translate,
	isPending,
	authenticationSetActionType,
}) => {
	const title =
		actionType === actionTypeEnum.NEW_PASSWORD
			? translate(codes.user.newPassword)
			: translate(codes.user.registerPassword);
	const description =
		actionType === actionTypeEnum.NEW_PASSWORD
			? translate(codes.user.expiredPasswordDescription)
			: translate(codes.user.pleaseRegisterYourNewPassword);
	return (
		<>
			{isPending && <CloakLoading />}
			{!isPending && (
				<>
					<AuthenticationTitle>{title}</AuthenticationTitle>
					<h4 className={classes.requirementsTitle}>{translate(codes.user.password)}</h4>
					<AuthenticationDescription>
						<UserPasswordRequirements
							weak={passwordRules.weakValidation}
							title={description}
							passwordMinimumLength={passwordRules.passwordMinimumLength}
							passwordUniqueness={passwordRules.passwordUniqueness}
							passwordMaximumAge={passwordRules.passwordMaximumAge}
						/>
					</AuthenticationDescription>
					<AuthenticationNewPasswordForm
						passwordRules={passwordRules}
						translate={translate}
						actionType={actionType}
						authenticationSetActionType={authenticationSetActionType}
					/>
				</>
			)}
		</>
	);
};

export const AuthenticationNewPassword = compose(
	AuthenticationContextConnect,
	AuthenticationFetchNewPassword,
	Translations,
)(AuthenticationNewPasswordComponent);
